<script setup lang="ts">
import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

import SearchLink from "./SearchLink.vue";

interface Props {
  searchDictionary?: string;
  searchDirection?: string;
  searchWords: string[];
}

withDefaults(defineProps<Props>(), {
  searchDictionary: undefined,
  searchDirection: undefined
});

const trackFuzzySuggestionClick = () => {
  MatomoHelper.sendEvent(
    MatomoEventCategory.Search,
    MatomoEventAction.ClickFuzzySuggestion,
    "Clicked button for suggestion"
  );
};
</script>

<template>
  <div class="search-link-list">
    {{ $t("article.searchLinkList.intro") }}
    <span v-for="(word, index) in searchWords" :key="index">
      <span>“</span>
      <SearchLink
        :search-dictionary="searchDictionary"
        :search-direction="searchDirection"
        :search-word="word"
        @click="trackFuzzySuggestionClick()"
        >{{ word }}</SearchLink
      >
      <span>”</span>
      <span v-if="index < searchWords.length - 2">, </span>
      <span v-else-if="index === searchWords.length - 2">{{
        $t("article.searchLinkList.or")
      }}</span>
    </span>
    <span>?</span>
  </div>
</template>
